import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Chip,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  Checkbox,
  Grid,
  Stack,
  IconButton,
  Tooltip,
  Divider,
  CircularProgress,
  Paper,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Modal,
} from '@mui/material';
import {
  Add as AddIcon,
  Settings as SettingsIcon,
  Delete as DeleteIcon,
  Check as CheckIcon,
  Close as CloseIcon,
  CalendarToday as CalendarIcon,
  Business as BusinessIcon,
  Chat as ChatIcon,
  Upload as UploadIcon,
  PlayArrow as TestIcon,
  MenuBook as KnowledgeIcon,
  Folder as FolderIcon,
  Build as BuildIcon,
  ExpandMore as ExpandMoreIcon,
  // Novos ícones profissionais para Data Collection
  People as PeopleIcon,
  Support as SupportIcon,
  Gavel as GavelIcon,
  Person as PersonIcon,
  Assessment as AssessmentIcon,
  Schedule as ScheduleIcon,
  Assignment as AssignmentIcon,
  ContactPhone as ContactPhoneIcon,
  BugReport as BugReportIcon,
  Feedback as FeedbackIcon,
  ContentCopy as ContentCopyIcon,
  Code as CodeIcon,
  Info as InfoIcon,
  List as ListIcon,
  Work as WorkIcon,
  ExpandLess as ExpandLessIcon,
} from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion';

import { integrationsService } from '../services/integrationsService';
import { agentsService } from '../services/agentsService';
import { ragService } from '../services/ragService';

const ToolsConfiguration = ({
  agentId,
  toolsConfig,
  onToolsConfigChange,
  availableTools,
  agentIntegrations,
  onIntegrationsChange,
  onAutoSave,
  isNewAgent,
  formData,
  hideKnowledgeBases = false,
  // 🚀 FASE 2: Novas props para bases de conhecimento (vem da página pai)
  agentKnowledgeBases = null,
  onKnowledgeBasesChange = null,
  kbLoading = false,
  kbError = null,
  onClearKbError = null,
}) => {
  const [configDialogOpen, setConfigDialogOpen] = useState(false);
  const [selectedTool, setSelectedTool] = useState(null);
  const [toolConfig, setToolConfig] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [testResults, setTestResults] = useState({});
  const [authorizationData, setAuthorizationData] = useState(null);
  
  // 🚀 FASE 2: Estados mantidos apenas para UI (dados vêm via props)
  const [knowledgeBasesExpanded, setKnowledgeBasesExpanded] = useState(true);
  const [integrationsExpanded, setIntegrationsExpanded] = useState(true);
  
  // 🚀 FASE 2: Carregamento removido - dados vêm da página pai via props

  // 🚀 FASE 2: loadAgentKnowledgeBases removida - dados vêm via props da página pai

  // Mapear ícones para ferramentas
  const getToolIcon = (toolId) => {
    const icons = {
      calendar: <CalendarIcon />,
      pipedrive: <BusinessIcon />,
    };
    return icons[toolId] || <SettingsIcon />;
  };

  // Verificar se ferramenta está configurada
  const isToolConfigured = (toolId) => {
    // Mapear toolId para integration_type para verificação
    const toolIdToIntegrationType = {
      'calendar': 'google_calendar',
      'pipedrive': 'pipedrive'
    };
    
    const integrationType = toolIdToIntegrationType[toolId] || toolId;
    
    return agentIntegrations.some(
      integration => integration.integration_type === integrationType && integration.is_active
    );
  };

  // Funções para gerenciar bases de conhecimento
  // 🚀 FASE 2: Modificado para usar dados da página pai e manter salvamento independente
  const handleKnowledgeBaseToggle = async (kbId, enabled) => {
    if (!agentId) {
      setError('Agente deve estar salvo antes de configurar bases de conhecimento');
      return;
    }

    try {
      console.log('🚀 [FASE 2] Alterando base de conhecimento:', kbId, 'enabled:', enabled);
      
      // 🔒 CRÍTICO: Manter salvamento independente via ragService
      await ragService.toggleAgentKnowledgeBase(agentId, {
        knowledge_base_id: kbId,
        enabled: enabled
      });
      
      // 🚀 FASE 2: Atualizar dados localmente e notificar página pai
      if (agentKnowledgeBases && onKnowledgeBasesChange) {
        const updatedKBs = agentKnowledgeBases.map(kb => 
          kb.id === kbId ? { ...kb, is_enabled: enabled } : kb
        );
        onKnowledgeBasesChange(updatedKBs);
      }
      
      // Notificar sucesso
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
      
      console.log('✅ [FASE 2] Base de conhecimento alterada com sucesso');
      
    } catch (err) {
      console.error('❌ [FASE 2] Erro ao alterar base de conhecimento:', err);
      setError('Erro ao alterar base de conhecimento: ' + err.message);
    }
  };

  const handleAddTool = async (tool) => {
    console.log('🔧 [TOOL_CONFIG] handleAddTool chamado para:', tool.id);
    console.log('🔧 [TOOL_CONFIG] isToolConfigured?', isToolConfigured(tool.id));
    
    if (isToolConfigured(tool.id)) {
      // Se já configurada, abrir dialog de edição
      // Mapear toolId para integration_type para busca
      const toolIdToIntegrationType = {
        'calendar': 'google_calendar',
        'pipedrive': 'pipedrive'
      };
      
      const integrationType = toolIdToIntegrationType[tool.id] || tool.id;
      console.log('🔧 [TOOL_CONFIG] Buscando integração com tipo:', integrationType);
      
      const integration = agentIntegrations.find(
        int => int.integration_type === integrationType
      );
      
      console.log('🔧 [TOOL_CONFIG] Integração encontrada:', integration);
      
      if (integration) {
        // Carregar a configuração completa da integração
        const configWithId = {
          ...integration.config,
          // Adicionar o ID da integração para permitir atualização em vez de criação
          integration_id: integration.id
        };
        
        console.log('🔧 [TOOL_CONFIG] Configuração carregada com integration_id:', configWithId);
        setToolConfig(configWithId);
      } else {
        console.error('🔧 [TOOL_CONFIG] Integração não encontrada! Criando config vazio');
        setToolConfig({});
      }
      
      // Não precisamos carregar pipelines e estágios aqui, pois o componente PipedriveConfig
      // já faz isso automaticamente no useEffect quando detecta um token válido
    } else {
      // Configurar nova ferramenta
      console.log('🔧 [TOOL_CONFIG] Ferramenta não configurada, criando config vazio');
      setToolConfig({});
    }
    setSelectedTool(tool);
    setConfigDialogOpen(true);
  };

  const handleRemoveTool = async (toolId) => {
    try {
      setLoading(true);
      
      // 🔧 SIMPLIFICADO: Mapear toolId para integration_type para encontrar integração
      const toolIdToIntegrationType = {
        'calendar': 'google_calendar',
        'pipedrive': 'pipedrive'
      };
      
      const integrationType = toolIdToIntegrationType[toolId] || toolId;
      
      // Encontrar integração
      const integration = agentIntegrations.find(
        int => int.integration_type === integrationType
      );
      
      if (integration) {
        // Deletar integração do banco
        await integrationsService.deleteIntegration(integration.id);
        
        // ✅ UNIFICADO: Usar updateToolConfigs() para reconstruir tools_config
        // Isso substitui toda a lógica manual anterior
        if (agentId) {
          console.log(`🗑️ Ferramenta ${toolId} removida, sincronizando tools_config...`);
          await updateToolConfigs(toolId, agentId);
          console.log(`✅ tools_config sincronizado após remoção de ${toolId}`);
        }
        
        // Disparar evento para notificar outros componentes
        const event = new CustomEvent('toolConfigSaved', {
          detail: { 
            toolType: toolId,
            message: `${toolId} removido com sucesso!` 
          }
        });
        window.dispatchEvent(event);
      }
    } catch (err) {
      setError('Erro ao remover ferramenta: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveToolConfig = async () => {
    try {
      setLoading(true);
      setError(null);

      let currentAgentId = agentId;

      // Auto-save se for um novo agente
      if (!agentId && isNewAgent && onAutoSave) {
        console.log('🔧 [AUTO_SAVE] Tentando auto-save para novo agente...');
        console.log('🔧 [AUTO_SAVE] selectedTool:', selectedTool?.id);
        
        try {
          currentAgentId = await onAutoSave();
          console.log('🔧 [AUTO_SAVE] Auto-save bem-sucedido, ID:', currentAgentId);
          
          if (!currentAgentId) {
            console.log('🔧 [AUTO_SAVE] Sem ID retornado, provavelmente houve redirect');
            // Se ainda não temos ID, significa que houve redirect
            // A configuração será preservada após o redirect
            return;
          }
        } catch (autoSaveError) {
          console.error('🔧 [AUTO_SAVE] Erro no auto-save:', autoSaveError);
          setError(`Primeiro salve o agente: ${autoSaveError.message}`);
          return;
        }
      }

      if (!currentAgentId) {
        setError('Salve o agente antes de configurar ferramentas');
        return;
      }

      // Verificar se é Google Calendar e processar upload
      if (selectedTool.id === 'calendar' && toolConfig.clientSecretFile) {
        await handleGoogleCalendarUpload(currentAgentId);
      } else if (selectedTool.id === 'pipedrive') {
        await handlePipedriveConfig(currentAgentId);
      } else {
        await handleGenericToolConfig(currentAgentId);
      }

      // Se chegou até aqui sem erros, fechar o diálogo
      setConfigDialogOpen(false);
      setSelectedTool(null);
      setToolConfig({});
      
      // Exibir mensagem de sucesso
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      console.error('Erro ao salvar configuração:', err);
      setError('Erro ao salvar configuração: ' + err.message);
      // Não fechar o diálogo em caso de erro
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleCalendarUpload = async (currentAgentId) => {
    const formData = new FormData();
    formData.append('agent_id', currentAgentId);
    formData.append('client_secret', toolConfig.clientSecretFile);
    formData.append('token_pickle', toolConfig.tokenPickleFile);
    formData.append('user_email', toolConfig.user_email);
    formData.append('calendar_id', toolConfig.calendar_id || 'primary');
    formData.append('timezone', toolConfig.timezone || 'America/Sao_Paulo');

    const result = await integrationsService.uploadGoogleCalendarConfig(formData);
    
    // Atualizar configurações
    console.log('🔧 [CALENDAR] Finalizando configuração do Google Calendar via upload');
    await updateToolConfigs('calendar', currentAgentId);
  };

  const handlePipedriveConfig = async (currentAgentId) => {
    try {
      console.log('🔧 [PIPEDRIVE] Iniciando configuração do Pipedrive para o agente:', currentAgentId);
      
      // IMPORTANTE: Verificar integrações ANTES de adicionar o Pipedrive
      console.log('🔧 [PIPEDRIVE] Verificando integrações existentes ANTES da configuração...');
      const integrationsBefore = await integrationsService.getAgentIntegrations(currentAgentId);
      console.log('🔧 [PIPEDRIVE] Integrações ANTES:', integrationsBefore.map(int => `${int.integration_type} (${int.is_active ? 'ativo' : 'inativo'})`));
      
      const config = {
        api_token: toolConfig.api_token,
        pipeline_id: toolConfig.pipeline_id,
        stage_id: toolConfig.stage_id,
        notes_field: toolConfig.notes_field || 'notes',
      };

      console.log('🔧 [PIPEDRIVE] Configuração do Pipedrive:', config);

      // Verificar se estamos atualizando uma integração existente ou criando uma nova
      if (toolConfig.integration_id) {
        console.log('🔧 [PIPEDRIVE] Atualizando integração existente do Pipedrive:', toolConfig.integration_id);
        
        // Atualizar integração existente
        const integrationData = {
          agent_id: currentAgentId,
          integration_type: 'pipedrive',
          config,
          is_active: true,
        };
        
        await integrationsService.updateIntegration(toolConfig.integration_id, integrationData);
        console.log('🔧 [PIPEDRIVE] Integração do Pipedrive atualizada com sucesso');
      } else {
        console.log('🔧 [PIPEDRIVE] Criando nova integração do Pipedrive');
        
        // Criar nova integração
        const integrationData = {
          agent_id: currentAgentId,
          integration_type: 'pipedrive',
          config,
          is_active: true,
        };
        
        const result = await integrationsService.createIntegration(integrationData);
        console.log('🔧 [PIPEDRIVE] Nova integração do Pipedrive criada:', result);
      }
      
      // Verificar integrações DEPOIS de adicionar o Pipedrive
      console.log('🔧 [PIPEDRIVE] Verificando integrações existentes DEPOIS da configuração...');
      const integrationsAfter = await integrationsService.getAgentIntegrations(currentAgentId);
      console.log('🔧 [PIPEDRIVE] Integrações DEPOIS:', integrationsAfter.map(int => `${int.integration_type} (${int.is_active ? 'ativo' : 'inativo'})`));
      
      // Adicionar um pequeno atraso para garantir que a integração foi salva no banco
      console.log('🔧 [PIPEDRIVE] Aguardando para sincronizar tools_config...');
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Atualizar tools_config
      console.log('🔧 [PIPEDRIVE] Chamando updateToolConfigs para o Pipedrive');
      await updateToolConfigs('pipedrive', currentAgentId);
      console.log('🔧 [PIPEDRIVE] updateToolConfigs concluído para o Pipedrive');
      
      return true; // Indicar sucesso
    } catch (error) {
      console.error('Erro ao configurar Pipedrive:', error);
      setError('Erro ao configurar Pipedrive: ' + error.message);
      throw error; // Propagar erro para ser tratado no handleSaveToolConfig
    }
  };

  const handleGenericToolConfig = async (currentAgentId) => {
    try {
      console.log('🔧 [GENERIC_CONFIG] Iniciando configuração para:', selectedTool?.id);
      console.log('🔧 [GENERIC_CONFIG] toolConfig recebido:', toolConfig);
      console.log('🔧 [GENERIC_CONFIG] toolConfig.integration_id:', toolConfig.integration_id);
      
      // Criar uma cópia do toolConfig para não modificar o original
      const configCopy = { ...toolConfig };
      
      // Remover o integration_id do objeto config antes de enviar para a API
      if (configCopy.integration_id) {
        delete configCopy.integration_id;
      }
      
      console.log('🔧 [GENERIC_CONFIG] configCopy (sem integration_id):', configCopy);
      
      // Verificar se estamos atualizando uma integração existente ou criando uma nova
      if (toolConfig.integration_id) {
        console.log('🔧 [GENERIC_CONFIG] ATUALIZANDO integração existente:', toolConfig.integration_id);
        
        // Atualizar integração existente
        // Com nossa nova abordagem, precisamos fornecer todos os dados necessários para criar uma nova integração
        
        // 🔧 CORREÇÃO: Mapear toolId para integration_type correto
        const toolIdToIntegrationType = {
          'calendar': 'google_calendar',
          'pipedrive': 'pipedrive'
        };
        const integrationType = toolIdToIntegrationType[selectedTool.id] || selectedTool.id;
        
        console.log('🔧 [GENERIC_CONFIG] integrationType para atualização:', integrationType);
        
        const integrationData = {
          agent_id: currentAgentId,
          integration_type: integrationType,
          config: configCopy,
          is_active: true,
        };
        
        console.log('🔧 [GENERIC_CONFIG] Dados para atualização:', integrationData);
        
        await integrationsService.updateIntegration(toolConfig.integration_id, integrationData);
        console.log('🔧 [GENERIC_CONFIG] Integração atualizada com sucesso');
      } else {
        console.log('🔧 [GENERIC_CONFIG] CRIANDO nova integração');
        
        // Criar nova integração
        
        // 🔧 CORREÇÃO: Mapear toolId para integration_type correto
        const toolIdToIntegrationType = {
          'calendar': 'google_calendar',
          'pipedrive': 'pipedrive'
        };
        const integrationType = toolIdToIntegrationType[selectedTool.id] || selectedTool.id;
        
        console.log('🔧 [GENERIC_CONFIG] integrationType para criação:', integrationType);
        
        const integrationData = {
          agent_id: currentAgentId,
          integration_type: integrationType,
          config: configCopy,
          is_active: true,
        };
        
        console.log('🔧 [GENERIC_CONFIG] Dados para criação:', integrationData);
        
        await integrationsService.createIntegration(integrationData);
        console.log('🔧 [GENERIC_CONFIG] Nova integração criada com sucesso');
      }
      
      await updateToolConfigs(selectedTool.id, currentAgentId);
      return true; // Indicar sucesso
    } catch (error) {
      console.error('Erro ao configurar ferramenta:', error);
      setError('Erro ao configurar ferramenta: ' + error.message);
      throw error; // Propagar erro para ser tratado no handleSaveToolConfig
    }
  };

  const updateToolConfigs = async (toolId, currentAgentId) => {
    try {
      console.log(`Iniciando updateToolConfigs para ${toolId} no agente ${currentAgentId}`);
      
      // Aguardar um pouco mais para garantir que a integração foi salva
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Recarregar integrações
      const updatedIntegrations = await integrationsService.getAgentIntegrations(currentAgentId);
      console.log('Integrações carregadas do banco:', updatedIntegrations);
      console.log('Número de integrações ativas:', updatedIntegrations.filter(int => int.is_active).length);
      
      // Verificar se temos todas as integrações esperadas
      const activeIntegrations = updatedIntegrations.filter(integration => integration.is_active);
      console.log('Integrações ativas:', activeIntegrations.map(int => int.integration_type));
      
      onIntegrationsChange(updatedIntegrations);
  
      // Atualizar tools_config do agente
      // Importante: Construir o tools_config baseado nas integrações atuais
      // para garantir que todas as ferramentas configuradas estejam presentes
      const updatedToolsConfig = activeIntegrations.map(integration => {
        // Mapear integration_type para o nome correto da ferramenta
        let toolName = integration.integration_type;
        
        // Corrigir inconsistência de nomenclatura entre frontend e backend
        if (integration.integration_type === 'google_calendar') {
          toolName = 'calendar'; // Backend espera 'calendar', não 'google_calendar'
        }
        
        return {
          name: toolName,
          enabled: true
        };
      });
      
      console.log('Novo tools_config construído:', updatedToolsConfig);
      
      // Verificar se temos pelo menos uma ferramenta
      if (updatedToolsConfig.length === 0) {
        console.warn('AVISO: Nenhuma ferramenta ativa encontrada!');
        return;
      }
      
      // Atualizar o estado local
      onToolsConfigChange(updatedToolsConfig);
      
      // IMPORTANTE: Atualizar diretamente o agente no banco de dados
      // para garantir que tools_config esteja sincronizado
      if (currentAgentId) {
        console.log('Atualizando tools_config do agente diretamente:', updatedToolsConfig);
        
        try {
          // Atualizar apenas o campo tools_config do agente
          const response = await agentsService.updateAgent(currentAgentId, {
            tools_config: updatedToolsConfig
          });
          
          console.log('Resposta da atualização do agente:', response);
          console.log('tools_config do agente atualizado com sucesso');
        } catch (updateError) {
          console.error('Erro ao atualizar tools_config do agente:', updateError);
          throw updateError;
        }
      }
      
      // Disparar evento com as ferramentas atualizadas para sincronizar com o estado do formulário principal
      const event = new CustomEvent('toolConfigSaved', {
        detail: { 
          toolType: toolId,
          tools_config: updatedToolsConfig,
          message: `${toolId} configurado com sucesso!` 
        }
      });
      window.dispatchEvent(event);
    } catch (error) {
      console.error('Erro ao atualizar tools_config:', error);
      // Em caso de erro, disparar evento com a mensagem de erro
      const errorEvent = new CustomEvent('toolConfigSaved', {
        detail: { 
          toolType: toolId,
          error: error.message
        }
      });
      window.dispatchEvent(errorEvent);
    }
  };

  const handleTestTool = async (toolId) => {
    try {
      setLoading(true);
      setTestResults(prev => ({ ...prev, [toolId]: { loading: true } }));

      let result;
      if (toolId === 'calendar') {
        result = await integrationsService.testGoogleCalendarIntegration(agentId);
      } else {
        result = { success: true, message: 'Teste não implementado para esta ferramenta' };
      }

      setTestResults(prev => ({
        ...prev,
        [toolId]: { loading: false, ...result },
      }));

      // Limpar resultado após 5 segundos
      setTimeout(() => {
        setTestResults(prev => {
          const updated = { ...prev };
          delete updated[toolId];
          return updated;
        });
      }, 5000);
    } catch (err) {
      setTestResults(prev => ({
        ...prev,
        [toolId]: { loading: false, success: false, message: err.message },
      }));
    } finally {
      setLoading(false);
    }
  };

  // Estado para notificação de sucesso sem diálogo modal
  const [successNotification, setSuccessNotification] = useState({ show: false, message: '' });
  
  // Expor função para fechar o diálogo do Google Calendar
  useEffect(() => {
    // Expor função para fechar o diálogo
    window.closeGoogleCalendarDialog = () => {
      setConfigDialogOpen(false);
      setSelectedTool(null);
      setToolConfig({});
      setAuthorizationData(null);
    };
    
    return () => {
      // Limpar função global quando o componente for desmontado
      delete window.closeGoogleCalendarDialog;
    };
  }, []);
  
  // Efeito para detectar quando o Google Calendar foi configurado com sucesso
  useEffect(() => {
    // Verificar se o Google Calendar foi configurado com sucesso
    if (toolConfig.autoClose && toolConfig.successMessage) {
      // Atualizar configurações
      if (selectedTool && selectedTool.id === 'calendar' && agentId) {
        console.log('🔧 [CALENDAR] Finalizando configuração do Google Calendar via OAuth');
        updateToolConfigs('calendar', agentId).then(() => {
          console.log('🔧 [CALENDAR] Configuração finalizada, fechando diálogo');
          // Fechar o diálogo de configuração sem mostrar alerta adicional
          setConfigDialogOpen(false);
          setSelectedTool(null);
          setToolConfig({});
        });
      }
    }
  }, [toolConfig.autoClose, toolConfig.successMessage, selectedTool, agentId]);

  const renderToolConfigFields = () => {
    if (!selectedTool) return null;

    switch (selectedTool.id) {
      case 'calendar':
        return (
          <GoogleCalendarConfig 
            config={toolConfig}
            onChange={setToolConfig}
            agentId={agentId}
            isNewAgent={isNewAgent}
            onAutoSave={onAutoSave}
            onAuthDataChange={setAuthorizationData}
            authorizationData={authorizationData}
            updateToolConfigs={updateToolConfigs}
          />
        );
      case 'pipedrive':
        return (
          <PipedriveConfig 
            config={toolConfig}
            onChange={setToolConfig}
          />
        );
      case 'data_collection':
        return (
          <DataCollectionConfig 
            config={toolConfig}
            onChange={setToolConfig}
            agentId={agentId}
          />
        );
      default:
        return (
          <GenericToolConfig 
            tool={selectedTool}
            config={toolConfig}
            onChange={setToolConfig}
          />
        );
    }
  };

  const enabledTools = agentIntegrations.filter(int => int.is_active);

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {kbError && (
        <Alert 
          severity="error" 
          sx={{ mb: 3 }} 
          onClose={onClearKbError ? onClearKbError : undefined}
        >
          {kbError}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 3 }} onClose={() => setSuccess(false)}>
          Configuração salva com sucesso!
        </Alert>
      )}

      {/* SEÇÃO 1: BASES DE CONHECIMENTO */}
      {!hideKnowledgeBases && (
        <Card variant="outlined" sx={{ mb: 3 }}>
          <CardContent>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 2,
                cursor: 'pointer',
              }}
              onClick={() => setKnowledgeBasesExpanded(!knowledgeBasesExpanded)}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <KnowledgeIcon sx={{ mr: 1, color: 'success.main' }} />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  📚 Bases de Conhecimento
                </Typography>
                <Chip
                  label={agentKnowledgeBases?.enabled_count || 0}
                  size="small"
                  color="success"
                  sx={{ ml: 2, minWidth: 24 }}
                />
              </Box>
              {knowledgeBasesExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            <Collapse in={knowledgeBasesExpanded}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Documentos e informações da empresa para consulta dos agentes.
              </Typography>

              {!agentId ? (
                <Alert severity="info" sx={{ mb: 2 }}>
                  <Typography variant="body2">
                    💡 Salve o agente primeiro para configurar bases de conhecimento.
                  </Typography>
                </Alert>
              ) : kbLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                  <CircularProgress size={24} />
                </Box>
              ) : !agentKnowledgeBases || agentKnowledgeBases.available_bases.length === 0 ? (
                <Alert severity="info" sx={{ mb: 2 }}>
                  <Typography variant="body2">
                    Nenhuma base de conhecimento encontrada. 
                    <Button 
                      variant="text" 
                      onClick={() => window.open('/admin/knowledge-bases', '_blank')}
                      sx={{ ml: 1 }}
                    >
                      Criar primeira base
                    </Button>
                  </Typography>
                </Alert>
              ) : (
                <Grid container spacing={2}>
                  {agentKnowledgeBases.available_bases.map((kb) => (
                    <Grid item xs={12} sm={6} md={4} key={kb.id}>
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <Paper
                          variant="outlined"
                          sx={{
                            p: 2,
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            border: '1px solid',
                            borderColor: kb.is_enabled ? 'success.main' : 'divider',
                            bgcolor: kb.is_enabled ? 'success.50' : 'background.paper',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                              borderColor: 'success.main',
                              boxShadow: 1,
                            },
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Box
                              sx={{
                                p: 1,
                                borderRadius: 2,
                                bgcolor: kb.is_enabled ? 'success.100' : 'grey.100',
                                mr: 1,
                              }}
                            >
                              <FolderIcon 
                                sx={{ 
                                  color: kb.is_enabled ? 'success.main' : 'grey.500', 
                                  fontSize: 20 
                                }} 
                              />
                            </Box>
                            
                            <Box sx={{ flexGrow: 1 }}>
                              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                {kb.name}
                              </Typography>
                            </Box>

                            <Switch
                              checked={kb.is_enabled}
                              onChange={(e) => handleKnowledgeBaseToggle(kb.id, e.target.checked)}
                              size="small"
                              color="success"
                              disabled={kbLoading}
                            />
                          </Box>

                          <Typography 
                            variant="body2" 
                            color="text.secondary" 
                            sx={{ 
                              mb: 2, 
                              flexGrow: 1,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                            }}
                          >
                            {kb.description || `Base de conhecimento com documentos sobre ${kb.name.toLowerCase()}`}
                          </Typography>

                          <Box sx={{ mt: 'auto' }}>
                            <Chip
                              label={kb.tool_name}
                              size="small"
                              color="success"
                              sx={{ fontSize: '0.75rem', mb: 1 }}
                            />
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                              {kb.documents_count} documentos • {kb.chunks_count} chunks
                            </Typography>
                          </Box>
                        </Paper>
                      </motion.div>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Collapse>
          </CardContent>
        </Card>
      )}

      {/* FERRAMENTAS E INTEGRAÇÕES */}
      <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Conecte serviços externos (CRM, calendários, etc.) para expandir as capacidades do seu agente.
            </Typography>

            {/* Alert informativo para novos agentes */}
            {isNewAgent && !agentId && (
              <Alert severity="info" sx={{ mb: 3 }}>
                <Typography variant="body2">
                  💡 <strong>Auto-save ativado:</strong> O agente será salvo automaticamente quando você configurar uma ferramenta.
                  Certifique-se de ter preenchido o nome e comportamento do agente.
                </Typography>
              </Alert>
            )}

            {/* Ferramentas Configuradas */}
            {enabledTools.length > 0 && (
              <>
                <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                  Ferramentas Ativas
                </Typography>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  {enabledTools.map((integration) => {
                    // 🔧 CORREÇÃO: Mapear integration_type para toolId para encontrar ferramenta
                    const integrationTypeToToolId = {
                      'google_calendar': 'calendar',
                      'pipedrive': 'pipedrive'
                    };
                    
                    const toolId = integrationTypeToToolId[integration.integration_type] || integration.integration_type;
                    const tool = availableTools.find(t => t.id === toolId);
                    if (!tool) return null;

                    const testResult = testResults[tool.id];

                    return (
                      <Grid item xs={12} sm={6} md={4} key={integration.id}>
                        <motion.div
                          initial={{ opacity: 0, scale: 0.9 }}
                          animate={{ opacity: 1, scale: 1 }}
                          transition={{ duration: 0.2 }}
                        >
                          <Paper
                            elevation={0}
                            sx={{
                              p: 1.5,
                              height: '140px',
                              display: 'flex',
                              flexDirection: 'column',
                              position: 'relative',
                              background: tool.id === 'calendar' 
                                ? 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' 
                                : tool.id === 'pipedrive' 
                                  ? 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)' 
                                  : 'linear-gradient(135deg, #6E53F2 0%, #201C5A 100%)',
                              borderRadius: 2,
                              color: 'white',
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                              <Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                width: 24, 
                                height: 24, 
                                borderRadius: '50%', 
                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                color: 'white',
                                mr: 1
                              }}>
                                {getToolIcon(tool.id)}
                              </Box>
                              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'white', fontSize: '0.875rem' }}>
                                {tool.name}
                              </Typography>
                              <Chip
                                label="Ativo"
                                size="small"
                                sx={{ 
                                  ml: 'auto', 
                                  height: 18, 
                                  fontSize: '0.65rem',
                                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                  color: 'white',
                                  fontWeight: 500
                                }}
                              />
                            </Box>

                            <Typography variant="body2" sx={{ mb: 1, flex: 1, color: 'rgba(255, 255, 255, 0.85)', fontSize: '0.75rem' }}>
                              {tool.description}
                            </Typography>

                            {/* Resultado do teste */}
                            {testResult && (
                              <Box sx={{ mb: 1 }}>
                                {testResult.loading ? (
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <CircularProgress size={12} />
                                    <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>Testando...</Typography>
                                  </Box>
                                ) : (
                                  <Alert 
                                    severity={testResult.success ? 'success' : 'error'}
                                    sx={{ py: 0.5, fontSize: '0.7rem' }}
                                  >
                                    <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                                      {testResult.message}
                                    </Typography>
                                  </Alert>
                                )}
                              </Box>
                            )}

                            <Box sx={{ display: 'flex', gap: 1, mt: 'auto' }}>
                              <Tooltip title="Configurar">
                                <IconButton
                                  size="small"
                                  onClick={() => handleAddTool(tool)}
                                  sx={{ color: 'white', p: 0.5 }}
                                >
                                  <SettingsIcon sx={{ fontSize: 16 }} />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Testar">
                                <IconButton
                                  size="small"
                                  onClick={() => handleTestTool(tool.id)}
                                  disabled={loading}
                                  sx={{ color: 'white', p: 0.5 }}
                                >
                                  <TestIcon sx={{ fontSize: 16 }} />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Remover">
                                <IconButton
                                  size="small"
                                  onClick={() => handleRemoveTool(tool.id)}
                                  disabled={loading}
                                  sx={{ color: 'white', p: 0.5 }}
                                >
                                  <DeleteIcon sx={{ fontSize: 16 }} />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Paper>
                        </motion.div>
                      </Grid>
                    );
                  })}
                </Grid>
                <Divider sx={{ mb: 3 }} />
              </>
            )}

            {/* Ferramentas Disponíveis */}
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
              Ferramentas Disponíveis
            </Typography>
            <Grid container spacing={2}>
              {availableTools.map((tool) => {
                const isConfigured = isToolConfigured(tool.id);

                return (
                  <Grid item xs={12} sm={6} md={4} key={tool.id}>
                    <motion.div
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 1.5,
                          height: '140px',
                          display: 'flex',
                          flexDirection: 'column',
                          cursor: isConfigured ? 'default' : 'pointer',
                          opacity: isConfigured ? 0.7 : 1,
                          backgroundColor: isConfigured ? 'action.hover' : 'background.paper',
                          '&:hover': {
                            borderColor: isConfigured ? 'divider' : 'primary.main',
                          },
                        }}
                        onClick={() => !isConfigured && handleAddTool(tool)}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            width: 24, 
                            height: 24, 
                            borderRadius: '50%', 
                            backgroundColor: isConfigured ? 'action.hover' : 'grey.100',
                            color: isConfigured ? 'text.secondary' : 'text.primary',
                            mr: 1
                          }}>
                            {getToolIcon(tool.id)}
                          </Box>
                          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: isConfigured ? 'text.secondary' : 'text.primary', fontSize: '0.875rem' }}>
                            {tool.name}
                          </Typography>
                          {isConfigured && (
                            <Chip
                              label="Configurado"
                              size="small"
                              color="default"
                              sx={{ ml: 'auto', height: 18, fontSize: '0.65rem' }}
                            />
                          )}
                        </Box>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, flex: 1, fontSize: '0.75rem' }}>
                          {tool.description}
                        </Typography>

                        <Button
                          fullWidth
                          variant={isConfigured ? "outlined" : "contained"}
                          startIcon={isConfigured ? <SettingsIcon sx={{ fontSize: 16 }} /> : <AddIcon sx={{ fontSize: 16 }} />}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAddTool(tool);
                          }}
                          disabled={false} // Agora sempre habilitado devido ao auto-save
                          size="small"
                          sx={{
                            fontSize: '0.75rem',
                            py: 0.5,
                            mt: 'auto',
                            ...(isNewAgent && !agentId && {
                              backgroundImage: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
                              color: 'white',
                              '&:hover': {
                                backgroundImage: 'linear-gradient(45deg, #FE6B8B 60%, #FF8E53 100%)',
                              },
                            }),
                          }}
                        >
                          {isConfigured 
                            ? 'Configurar' 
                            : isNewAgent && !agentId 
                              ? 'Salvar e Configurar' 
                              : 'Adicionar'
                          }
                        </Button>
                      </Paper>
                    </motion.div>
                  </Grid>
                );
              })}
            </Grid>
      </Box>

      {/* Dialog de Configuração */}
      <Dialog
        open={configDialogOpen}
        onClose={() => setConfigDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2 }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {selectedTool && getToolIcon(selectedTool.id)}
            <Typography variant="h6">
              Configurar {selectedTool?.name}
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          {renderToolConfigFields()}
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          {/* Mostrar apenas botão Fechar quando estiver no modo de autorização do Google Calendar */}
          {selectedTool && selectedTool.id === 'calendar' && authorizationData ? (
            <Button onClick={() => setConfigDialogOpen(false)}>
              Fechar
            </Button>
          ) : (
            <>
              <Button onClick={() => setConfigDialogOpen(false)}>
                Cancelar
              </Button>
              {/* Não mostrar botão Salvar para Google Calendar - o fluxo é direto: ou gera token ou cancela */}
              {!(selectedTool && selectedTool.id === 'calendar') && (
                <Button
                  variant="contained"
                  onClick={handleSaveToolConfig}
                  disabled={loading}
                  startIcon={loading ? <CircularProgress size={18} /> : <CheckIcon />}
                >
                  {loading ? 'Salvando...' : 'Salvar'}
                </Button>
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

// Componente específico para configuração do Google Calendar
const GoogleCalendarConfig = ({ config, onChange, agentId, isNewAgent, onAutoSave, onAuthDataChange, authorizationData: parentAuthData, updateToolConfigs }) => {
  const [generatingToken, setGeneratingToken] = useState(false);
  const [authorizationData, setAuthorizationData] = useState(parentAuthData || null);
  const [authCode, setAuthCode] = useState('');
  const [eventConfigPreview, setEventConfigPreview] = useState(null);
  const [allowedOrigins, setAllowedOrigins] = useState([]);
  
  // Carregar configurações ao montar o componente
  useEffect(() => {
    const loadConfig = async () => {
      try {
        const integConfig = await integrationsService.getConfig();
        setAllowedOrigins(integConfig.oauth_allowed_origins || []);
      } catch (error) {
        console.error('Erro ao carregar configurações:', error);
        // Fallback caso não consiga carregar
        setAllowedOrigins([
          window.location.origin,
          'https://fabricadeagentes.ai',
          'https://api.fabricadeagentes.ai'
        ]);
      }
    };
    
    loadConfig();
  }, []);

  // Sincronizar estado de autorização com o componente pai
  useEffect(() => {
    if (onAuthDataChange) {
      onAuthDataChange(authorizationData);
    }
  }, [authorizationData, onAuthDataChange]);

  // 🆕 Listener para postMessage do Google OAuth (modo produção)
  useEffect(() => {
    const handleGoogleOAuthMessage = (event) => {
      console.log('🔧 [CALENDAR] Recebida mensagem postMessage:', {
        origin: event.origin,
        type: event.data?.type,
        hasCode: !!event.data?.code,
        hasState: !!event.data?.state
      });
      
      // Verificar origem por segurança usando configurações dinâmicas
      if (allowedOrigins.length === 0) {
        console.log('🔧 [CALENDAR] Configurações ainda não carregadas, ignorando evento');
        console.log('🔧 [CALENDAR] Evento completo:', event);
        return;
      }
      
      console.log('🔧 [CALENDAR] Verificando origem:', event.origin);
      console.log('🔧 [CALENDAR] Origens permitidas:', allowedOrigins);
      
      const isValidOrigin = allowedOrigins.some(origin => {
        // Normalizar URLs para comparação
        const normalizedOrigin = origin.replace(/^https?:\/\//, '');
        const normalizedEventOrigin = event.origin.replace(/^https?:\/\//, '');
        
        const isValid = normalizedEventOrigin === normalizedOrigin || 
               normalizedEventOrigin.endsWith(normalizedOrigin) ||
               event.origin === origin;
               
        console.log('🔧 [CALENDAR] Comparando:', {
          origin: event.origin,
          normalizedEventOrigin,
          allowedOrigin: origin,
          normalizedOrigin,
          isValid
        });
        
        return isValid;
      });
      
      if (!isValidOrigin) {
        console.warn('🔧 [CALENDAR] Origem não permitida para OAuth:', event.origin);
        console.warn('🔧 [CALENDAR] Origens permitidas:', allowedOrigins);
        // Ainda assim vamos processar para debug
        console.warn('🔧 [CALENDAR] Processando mesmo assim para debug...');
      }
      
      if (event.data?.type === 'google_oauth_success') {
        console.log('🔧 [CALENDAR] Recebido código OAuth via postMessage:', event.data);
        console.log('🔧 [CALENDAR] Origem:', event.origin);
        console.log('🔧 [CALENDAR] authorizationData:', authorizationData);
        
        // Completar autorização automaticamente
        if (authorizationData && event.data.code && event.data.state) {
          console.log('🔧 [CALENDAR] Chamando handleCompleteAuthAutomatic...');
          handleCompleteAuthAutomatic(event.data.code, event.data.state);
        } else {
          console.error('🔧 [CALENDAR] Dados insuficientes para completar OAuth:', {
            authorizationData: !!authorizationData,
            code: !!event.data.code,
            state: !!event.data.state,
            fullAuthData: authorizationData,
            eventData: event.data
          });
        }
      } else {
        console.log('🔧 [CALENDAR] Mensagem recebida mas não é google_oauth_success:', event.data?.type);
      }
    };

    window.addEventListener('message', handleGoogleOAuthMessage);
    
    return () => {
      window.removeEventListener('message', handleGoogleOAuthMessage);
    };
  }, [authorizationData, allowedOrigins]);

  const handleGenerateToken = async () => {
    let currentAgentId = agentId;

    // Auto-save se for um novo agente
    if (!agentId && isNewAgent && onAutoSave) {
      try {
        currentAgentId = await onAutoSave();
        if (!currentAgentId) {
          alert('Primeiro complete as informações básicas do agente (nome e comportamento)');
          return;
        }
      } catch (autoSaveError) {
        alert(`Primeiro salve o agente: ${autoSaveError.message}`);
        return;
      }
    }

    if (!currentAgentId) {
      alert('Salve o agente antes de configurar o Google Calendar');
      return;
    }

    try {
      setGeneratingToken(true);
      
      const result = await integrationsService.generateGoogleCalendarToken(
        currentAgentId,
        config.user_email || '',
        config.calendar_id || 'primary',
        config.timezone || 'America/Sao_Paulo'
      );

      setAuthorizationData(result);
      setEventConfigPreview(result.event_config_preview);
      
      // Abrir URL de autorização em nova aba
      window.open(result.authorization_url, '_blank');
      
    } catch (error) {
      console.error('Erro ao gerar token:', error);
      alert('Erro ao gerar token: ' + error.message);
    } finally {
      setGeneratingToken(false);
    }
  };

  // 🆕 Função automática para completar OAuth (modo produção)
  const handleCompleteAuthAutomatic = async (code, state) => {
    try {
      setGeneratingToken(true);
      
      const result = await integrationsService.completeGoogleCalendarAuth(
        code,
        state,
        authorizationData.temp_config_id
      );
      
      // Limpar dados de autorização
      setAuthorizationData(null);
      setAuthCode('');
      
      console.log('🔧 [CALENDAR] Google Calendar configurado via OAuth automático, atualizando tools_config...');
      
      // IMPORTANTE: Chamar updateToolConfigs diretamente aqui
      if (agentId) {
        await updateToolConfigs('calendar', agentId);
      }
      
      // Notificar componente pai que a configuração foi bem-sucedida
      onChange(prev => ({ 
        ...prev, 
        configured: true, 
        integration_id: result.integration_id,
        autoClose: true,
        successMessage: 'Google Calendar configurado com sucesso!'
      }));
      
      console.log('🔧 [CALENDAR] Fechando diálogo do Google Calendar automaticamente');
      
    } catch (error) {
      console.error('Erro ao completar autorização automática:', error);
      alert('Erro ao completar autorização: ' + error.message);
    } finally {
      setGeneratingToken(false);
    }
  };

  const handleCompleteAuth = async () => {
    if (!authCode.trim() || !authorizationData) {
      alert('Digite o código de autorização');
      return;
    }

    try {
      setGeneratingToken(true);
      
      const result = await integrationsService.completeGoogleCalendarAuth(
        authCode,
        authorizationData.state,
        authorizationData.temp_config_id
      );
      
      // Limpar dados de autorização
      setAuthorizationData(null);
      setAuthCode('');
      
      console.log('🔧 [CALENDAR] Google Calendar configurado via OAuth, atualizando tools_config...');
      
      // IMPORTANTE: Chamar updateToolConfigs diretamente aqui, assim como o Pipedrive faz
      // Isso garante que a página do agente seja atualizada corretamente
      if (agentId) {
        await updateToolConfigs('calendar', agentId);
      }
      
      // Notificar componente pai que a configuração foi bem-sucedida
      onChange(prev => ({ 
        ...prev, 
        configured: true, 
        integration_id: result.integration_id,
        autoClose: true, // Sinalizar para fechar o diálogo automaticamente,
        successMessage: 'Google Calendar configurado com sucesso!'
      }));
      
      console.log('🔧 [CALENDAR] Fechando diálogo do Google Calendar');
      
      // Fechar o diálogo automaticamente
      if (typeof window.closeGoogleCalendarDialog === 'function') {
        window.closeGoogleCalendarDialog();
      } else {
        // Método alternativo para fechar o diálogo
        document.querySelector('button[aria-label="close"]')?.click();
      }
      
    } catch (error) {
      console.error('Erro ao completar autorização:', error);
      alert('Erro ao completar autorização: ' + error.message);
    } finally {
      setGeneratingToken(false);
    }
  };

  return (
    <Stack spacing={3}>
      <Alert severity="info">
        <Typography variant="body2" sx={{ mb: 1 }}>
          Para configurar o Google Calendar, você precisa autorizar o acesso.
          O sistema irá gerar automaticamente as configurações específicas do seu agente.
        </Typography>
      </Alert>

      <TextField
        fullWidth
        label="Email do usuário *"
        type="email"
        value={config.user_email || ''}
        onChange={(e) => onChange(prev => ({ ...prev, user_email: e.target.value }))}
        required
        helperText="Email que será usado para acessar o Google Calendar"
      />

      <FormControl fullWidth>
        <InputLabel>Timezone</InputLabel>
        <Select
          value={config.timezone || 'America/Sao_Paulo'}
          onChange={(e) => onChange(prev => ({ ...prev, timezone: e.target.value }))}
          label="Timezone"
        >
          <MenuItem value="America/Sao_Paulo">America/Sao_Paulo</MenuItem>
          <MenuItem value="America/New_York">America/New_York</MenuItem>
          <MenuItem value="Europe/London">Europe/London</MenuItem>
          <MenuItem value="UTC">UTC</MenuItem>
        </Select>
      </FormControl>

      <TextField
        fullWidth
        label="Calendar ID"
        value={config.calendar_id || 'primary'}
        onChange={(e) => onChange(prev => ({ ...prev, calendar_id: e.target.value }))}
        helperText="Geralmente 'primary' para o calendário principal"
      />

      {/* Preview da configuração do agente */}
      {eventConfigPreview && (
        <Card variant="outlined" sx={{ p: 2, bgcolor: 'background.default' }}>
          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
            📋 Configuração gerada para este agente:
        </Typography>
          <Box sx={{ pl: 2 }}>
            <Typography variant="body2">• Tipo: {eventConfigPreview.event_type_display}</Typography>
            <Typography variant="body2">• Duração: {eventConfigPreview.default_duration} minutos</Typography>
            <Typography variant="body2">• Empresa: {eventConfigPreview.company_name}</Typography>
            <Typography variant="body2">• Agenda: {eventConfigPreview.agenda_items?.length || 0} itens</Typography>
            <Typography variant="body2">• Recursos: {eventConfigPreview.company_resources?.length || 0} recursos</Typography>
          </Box>
        </Card>
      )}

      {/* Etapa 1: Gerar URL de autorização */}
      {!authorizationData && (
        <Button
          variant="contained"
          onClick={handleGenerateToken}
          disabled={!config.user_email || generatingToken}
          startIcon={generatingToken ? <CircularProgress size={18} /> : <CalendarIcon />}
          fullWidth
        >
          {generatingToken ? 'Gerando...' : 'Gerar Token de Acesso'}
        </Button>
      )}

      {/* Etapa 2: Inserir código de autorização */}
      {authorizationData && (
      <Box>
          <Alert severity="success" sx={{ mb: 3 }} icon={<CalendarIcon />}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
              Autorização do Google Calendar em andamento
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Uma nova aba foi aberta no seu navegador para autorização.
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Chip label="1" size="small" color="primary" sx={{ minWidth: 24 }} />
                <Typography variant="body2">
                  Faça login com <strong>{config.user_email}</strong>
                </Typography>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Chip label="2" size="small" color="primary" sx={{ minWidth: 24 }} />
                <Typography variant="body2">
                  Clique em "Continuar" para autorizar o acesso
                </Typography>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Chip label="3" size="small" color="primary" sx={{ minWidth: 24 }} />
                <Typography variant="body2">
                  O Google exibirá um <strong>código de autorização</strong>
                </Typography>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Chip label="4" size="small" color="primary" sx={{ minWidth: 24 }} />
                <Typography variant="body2">
                  <strong>Copie esse código</strong> e cole abaixo para finalizar
                </Typography>
              </Box>
            </Box>
          </Alert>

          <TextField
            fullWidth
            label="Código de Autorização"
            value={authCode}
            onChange={(e) => setAuthCode(e.target.value)}
            placeholder="Cole aqui o código obtido do Google"
            multiline
            rows={2}
            sx={{ mb: 3 }}
            autoFocus
          />

          {/* Botão único que processa o código e salva automaticamente */}
          <Button
            variant="contained"
            onClick={handleCompleteAuth}
            disabled={!authCode.trim() || generatingToken}
            startIcon={generatingToken ? <CircularProgress size={18} /> : <CheckIcon />}
            fullWidth
            size="large"
            sx={{
              py: 1.2,
              backgroundImage: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
              boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
            }}
          >
            {generatingToken ? 'Configurando...' : 'Processar e Salvar'}
          </Button>
        </Box>
      )}
    </Stack>
  );
};

// Componente específico para configuração do Pipedrive
const PipedriveConfig = ({ config, onChange }) => {
  const [pipelines, setPipelines] = useState([]);
  const [stages, setStages] = useState([]);
  const [tokenValid, setTokenValid] = useState(false);
  const [loading, setLoading] = useState(false);
  
  // Verificar se já temos uma configuração válida ao carregar o componente
  useEffect(() => {
    const initializeConfig = async () => {
      // Se temos um token API na configuração, validar e carregar dados
      if (config.api_token) {
        try {
          setLoading(true);
          
          // Se já temos pipeline_id configurado, consideramos o token válido
          // para evitar problemas de validação durante a edição
          if (config.pipeline_id) {
            setTokenValid(true);
            
            // Carregar pipelines disponíveis
            const pipelinesResult = await integrationsService.getPipedrivesPipelines(config.api_token);
            setPipelines(pipelinesResult.pipelines || []);
            
            // Carregar estágios do pipeline configurado
            await loadStages(config.pipeline_id);
          } else {
            // Se não temos pipeline_id, validar o token normalmente
            await validateToken(config.api_token);
          }
        } catch (error) {
          console.error('Erro ao inicializar configuração do Pipedrive:', error);
          // Mesmo com erro, manteremos o token válido se já temos pipeline_id
          // para permitir a edição da configuração existente
          if (config.pipeline_id) {
            setTokenValid(true);
          }
        } finally {
          setLoading(false);
        }
      }
    };
    
    initializeConfig();
  }, []);

  const validateToken = async (token) => {
    if (!token) return;
    
    try {
      setLoading(true);
      const result = await integrationsService.validatePipedriveToken(token);
      setTokenValid(result.valid);
      
      if (result.valid) {
        const pipelinesResult = await integrationsService.getPipedrivesPipelines(token);
        setPipelines(pipelinesResult.pipelines);
      }
    } catch (error) {
      setTokenValid(false);
    } finally {
      setLoading(false);
    }
  };

  const loadStages = async (pipelineId) => {
    if (!config.api_token || !pipelineId) return;
    
    try {
      const stagesResult = await integrationsService.getPipelineStages(
        config.api_token,
        pipelineId
      );
      setStages(stagesResult.stages);
    } catch (error) {
      console.error('Erro ao carregar estágios:', error);
    }
  };

  return (
    <Stack spacing={3}>
      <Alert severity="info">
        <Typography variant="body2">
          Configure sua integração com o Pipedrive para permitir que o agente crie oportunidades e gerencie leads.
        </Typography>
      </Alert>

      <TextField
        fullWidth
        label="API Token do Pipedrive *"
        type="password"
        value={config.api_token || ''}
        onChange={(e) => {
          onChange(prev => ({ ...prev, api_token: e.target.value }));
          validateToken(e.target.value);
        }}
        required
        helperText="Token de API encontrado nas configurações do Pipedrive"
      />

      {tokenValid && (
        <>
          <FormControl fullWidth>
            <InputLabel>Pipeline</InputLabel>
            <Select
              value={config.pipeline_id || ''}
              onChange={(e) => {
                onChange(prev => ({ ...prev, pipeline_id: e.target.value }));
                loadStages(e.target.value);
              }}
              label="Pipeline"
            >
              {pipelines.map((pipeline) => (
                <MenuItem key={pipeline.id} value={pipeline.id}>
                  {pipeline.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {stages.length > 0 && (
            <FormControl fullWidth>
              <InputLabel>Estágio Inicial</InputLabel>
              <Select
                value={config.stage_id || ''}
                onChange={(e) => onChange(prev => ({ ...prev, stage_id: e.target.value }))}
                label="Estágio Inicial"
              >
                {stages.map((stage) => (
                  <MenuItem key={stage.id} value={stage.id}>
                    {stage.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <TextField
            fullWidth
            label="Campo de Notas"
            value={config.notes_field || 'notes'}
            onChange={(e) => onChange(prev => ({ ...prev, notes_field: e.target.value }))}
            helperText="Campo onde serão salvas as anotações do agente"
          />
        </>
      )}
    </Stack>
  );
};

// Componente genérico para outras ferramentas
const GenericToolConfig = ({ tool, config, onChange }) => {
  return (
    <Stack spacing={3}>
      <Alert severity="info">
        <Typography variant="body2">
          Configuração para {tool.name} será implementada em breve.
        </Typography>
      </Alert>
      
      <TextField
        fullWidth
        label="Configuração JSON"
        value={JSON.stringify(config, null, 2)}
        onChange={(e) => {
          try {
            const parsed = JSON.parse(e.target.value);
            onChange(parsed);
          } catch (err) {
            // Ignorar erros de parsing durante a digitação
          }
        }}
        multiline
        rows={6}
        placeholder='{"key": "value"}'
        helperText="Configure a ferramenta usando formato JSON"
      />
    </Stack>
  );
};

// Componente específico para configuração do Data Collection - VERSÃO DINÂMICA
const DataCollectionConfig = ({ config, onChange, agentId }) => {
  const [groupedTemplates, setGroupedTemplates] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [validationMode, setValidationMode] = useState('relaxed');
  const [autoSaveMode, setAutoSaveMode] = useState(true);
  const [totalTemplates, setTotalTemplates] = useState(0);
  const [totalDomains, setTotalDomains] = useState(0);
  const [promptModalOpen, setPromptModalOpen] = useState(false);
  const [generatedPrompt, setGeneratedPrompt] = useState('');

  // Carregar templates agrupados dinamicamente
  useEffect(() => {
    loadGroupedTemplates();
  }, []);

  // Inicializar configuração existente
  useEffect(() => {
    if (config && config.data_collection_config) {
      const dcConfig = config.data_collection_config;
      setSelectedTemplates(dcConfig.enabled_schemas || []);
      setValidationMode(dcConfig.validation_mode || 'relaxed');
      setAutoSaveMode(dcConfig.auto_save_mode !== false); // Default true
    }
  }, [config]);

  const loadGroupedTemplates = async () => {
    try {
      setLoading(true);
      const response = await fetch('http://localhost:8000/api/v1/data-collection/templates/grouped', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Erro ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      setGroupedTemplates(data.grouped_templates || {});
      setTotalTemplates(data.total_templates || 0);
      setTotalDomains(data.total_domains || 0);
    } catch (err) {
      console.error('Erro ao carregar templates agrupados:', err);
      setError('Erro ao carregar templates disponíveis: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleTemplateToggle = (templateName, checked) => {
    let newSelectedTemplates;
    
    if (checked) {
      newSelectedTemplates = [...selectedTemplates, templateName];
    } else {
      newSelectedTemplates = selectedTemplates.filter(t => t !== templateName);
    }
    
    setSelectedTemplates(newSelectedTemplates);
    updateConfiguration(newSelectedTemplates, validationMode, autoSaveMode);
  };

  const handleValidationModeChange = (newMode) => {
    setValidationMode(newMode);
    updateConfiguration(selectedTemplates, newMode, autoSaveMode);
  };

  const handleAutoSaveModeChange = (newAutoSave) => {
    setAutoSaveMode(newAutoSave);
    updateConfiguration(selectedTemplates, validationMode, newAutoSave);
  };

  const updateConfiguration = (templates, validation, autoSave) => {
    const newConfig = {
      ...config, // 🔧 CORREÇÃO: Preservar todas as propriedades existentes (incluindo integration_id)
      data_collection_config: {
        enabled_schemas: templates,
        validation_mode: validation,
        auto_save_mode: autoSave,
        collection_flow: {
          allow_skip: false,
          sequential: true,
          restart_on_topic_change: true
        }
      }
    };
    
    console.log('🔧 [DATA_COLLECTION] updateConfiguration - config original:', config);
    console.log('🔧 [DATA_COLLECTION] updateConfiguration - newConfig com integration_id preservado:', newConfig);
    
    onChange(newConfig);
  };

  // Função para gerar prompt e abrir modal
  const handleGeneratePrompt = (selectedTemplates, groupedTemplates) => {
    try {
      const promptInstructions = generatePromptInstructions(selectedTemplates, groupedTemplates);
      setGeneratedPrompt(promptInstructions);
      setPromptModalOpen(true);
    } catch (error) {
      console.error('Erro ao gerar instruções:', error);
      alert('Erro ao gerar instruções de prompt: ' + error.message);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Carregando templates...</Typography>
      </Box>
    );
  }

      if (error) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
        <Button onClick={loadGroupedTemplates} sx={{ mt: 1 }}>
          Tentar Novamente
        </Button>
      </Alert>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Configurar Data Collection
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Selecione os templates que este agente pode usar para coletar dados estruturados.
      </Typography>

      {/* Configurações Gerais - Compactas */}
      <Box sx={{ 
        p: 1.5, 
        mb: 2, 
        border: '1px solid', 
        borderColor: 'divider', 
        borderRadius: 1, 
        bgcolor: 'grey.50' 
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="subtitle2" fontWeight="medium">
            Configurações Gerais
          </Typography>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <InputLabel>Modo de Validação</InputLabel>
              <Select
                value={validationMode}
                onChange={(e) => handleValidationModeChange(e.target.value)}
                label="Modo de Validação"
              >
                <MenuItem value="relaxed">Relaxado (Aceita formatos flexíveis)</MenuItem>
                <MenuItem value="strict">Rigoroso (Validação estrita)</MenuItem>
              </Select>
            </FormControl>
            
            <FormControlLabel
              control={
                <Switch
                  checked={autoSaveMode}
                  onChange={(e) => handleAutoSaveModeChange(e.target.checked)}
                  size="small"
                />
              }
              label="Salvamento Automático"
              sx={{ m: 0 }}
            />
          </Box>
        </Box>
      </Box>

      {/* Seleção de Templates Agrupados */}
      <Typography variant="subtitle2" gutterBottom>
        Templates Disponíveis ({totalTemplates} em {totalDomains} domínios)
      </Typography>
      
      {totalTemplates === 0 ? (
        <Alert severity="info">
          Nenhum template disponível para sua empresa. Entre em contato com o suporte para configurar templates.
        </Alert>
      ) : (
        <Box sx={{ maxHeight: 500, overflow: 'auto' }}>
          {Object.entries(groupedTemplates).map(([domainKey, domainData]) => (
            <Accordion key={domainKey} sx={{ mb: 1 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {getDomainIcon(domainKey)}
                    <Typography variant="subtitle1" fontWeight="bold">
                      {domainData.display_name}
                    </Typography>
                    <Chip 
                      label={`${domainData.total_templates} templates`}
                      size="small"
                      color="primary"
                      sx={{ fontSize: '0.7rem' }}
                    />
                  </Box>
                  
                  {domainData.process_description && (
                    <Tooltip title={domainData.process_description} placement="left">
                      <IconButton size="small">
                        <InfoIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              </AccordionSummary>
              
              <AccordionDetails sx={{ pt: 0 }}>
                {/* Descrição do Processo */}
                {domainData.process_description && (
                  <Alert severity="info" sx={{ mb: 2, py: 0.5 }}>
                    <Typography variant="caption">
                      {domainData.process_description}
                    </Typography>
                  </Alert>
                )}
                
                {/* Templates ordenados por usage_order - SEM agrupamento por categoria */}
                {(() => {
                  // Coletar todos os templates do domínio e ordenar por usage_order
                  const allTemplates = [];
                  Object.values(domainData.categories).forEach(categoryData => {
                    allTemplates.push(...categoryData.templates);
                  });
                  
                  // Ordenar por usage_order
                  allTemplates.sort((a, b) => (a.usage_order || 999) - (b.usage_order || 999));
                  
                  return allTemplates.map((template, index) => (
                    <Box key={template.id} sx={{ 
                      py: 1.5, 
                      px: 1,
                      borderBottom: index < allTemplates.length - 1 ? '1px solid' : 'none', 
                      borderColor: 'divider',
                      '&:hover': { bgcolor: 'grey.50' }
                    }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedTemplates.includes(template.template_name)}
                            onChange={(e) => handleTemplateToggle(template.template_name, e.target.checked)}
                            size="small"
                          />
                        }
                        label={
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <Box sx={{ flex: 1 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                {getCategoryIcon(template.category)}
                                <Typography variant="body2" fontWeight="medium">
                                  {template.display_name}
                                </Typography>
                                {template.usage_order && (
                                  <Chip 
                                    label={template.usage_order}
                                    size="small" 
                                    color="primary"
                                    sx={{ 
                                      fontSize: '0.6rem', 
                                      minWidth: '20px', 
                                      height: '18px',
                                      '& .MuiChip-label': { px: 0.5 }
                                    }}
                                  />
                                )}
                                {template.is_system && (
                                  <Chip 
                                    label="Sistema" 
                                    size="small" 
                                    color="secondary"
                                    variant="outlined"
                                    sx={{ fontSize: '0.6rem', height: '18px' }}
                                  />
                                )}
                              </Box>
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                {template.description}
                              </Typography>
                            </Box>
                            
                            {/* Tooltip com informações detalhadas */}
                            {template.when_to_use && (
                              <Tooltip 
                                title={
                                  <Box>
                                    <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block' }}>
                                      Quando usar:
                                    </Typography>
                                    <Typography variant="caption">
                                      {template.when_to_use}
                                    </Typography>
                                  </Box>
                                }
                                placement="left"
                              >
                                <IconButton size="small">
                                  <InfoIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        }
                        sx={{ width: '100%', m: 0 }}
                      />
                    </Box>
                  ));
                })()}
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      )}

      {/* Resumo da Configuração */}
      {selectedTemplates.length > 0 && (
        <Alert severity="success" sx={{ mt: 2 }}>
          <Typography variant="body2">
            <strong>{selectedTemplates.length} templates selecionados:</strong>
          </Typography>
          <Typography variant="caption">
            {selectedTemplates.join(', ')}
          </Typography>
          <Box sx={{ mt: 1 }}>
            <Button 
              onClick={() => handleGeneratePrompt(selectedTemplates, groupedTemplates)} 
              variant="outlined" 
              color="info"
              size="small"
              startIcon={<CodeIcon />}
            >
              Gerar Instruções para Prompt
            </Button>
          </Box>
        </Alert>
      )}
      
      {/* Modal para Instruções de Prompt */}
      <Dialog 
        open={promptModalOpen} 
        onClose={() => setPromptModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CodeIcon />
            <Typography variant="h6">Instruções de Prompt Geradas</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ mb: 2 }}>
            <Typography variant="body2">
              Templates selecionados: <strong>{selectedTemplates.length}</strong> | 
              Domínios: <strong>{Object.keys(groupedTemplates).filter(domain => 
                Object.values(groupedTemplates[domain].categories).some(cat => 
                  cat.templates.some(t => selectedTemplates.includes(t.template_name))
                )
              ).join(', ')}</strong>
            </Typography>
          </Alert>
          
          <Box sx={{ 
            bgcolor: 'grey.100', 
            p: 2, 
            borderRadius: 1, 
            maxHeight: 400, 
            overflow: 'auto',
            fontFamily: 'monospace',
            fontSize: '0.875rem',
            whiteSpace: 'pre-wrap'
          }}>
            {generatedPrompt}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => navigator.clipboard.writeText(generatedPrompt)}
            startIcon={<ContentCopyIcon />}
            variant="outlined"
          >
            Copiar para Clipboard
          </Button>
          <Button onClick={() => setPromptModalOpen(false)}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

// 🚀 FUNÇÃO MELHORADA: Gerar Instruções de Prompt Inteligente
// Usa TODOS os campos ricos da tabela: prompt_instructions, when_to_use, business_rules, etc.
const generatePromptInstructions = (selectedTemplates, groupedTemplates) => {
  try {
    // Organizar templates selecionados por domínio e ordem (mantém lógica atual)
    const templatesByDomain = {};
    const allSelectedTemplates = [];
    
    Object.entries(groupedTemplates).forEach(([domain, domainData]) => {
      Object.entries(domainData.categories).forEach(([category, categoryData]) => {
        categoryData.templates.forEach(template => {
          if (selectedTemplates.includes(template.template_name)) {
            if (!templatesByDomain[domain]) {
              templatesByDomain[domain] = {
                process_description: domainData.process_description,
                templates: []
              };
            }
            templatesByDomain[domain].templates.push(template);
            allSelectedTemplates.push(template);
          }
        });
      });
    });
    
    // Ordenar templates por usage_order
    Object.keys(templatesByDomain).forEach(domain => {
      templatesByDomain[domain].templates.sort((a, b) => (a.usage_order || 999) - (b.usage_order || 999));
    });
    
    let instructions = '';
    
    // ====================================================================
    // CABEÇALHO RICO COM CONTEXTO
    // ====================================================================
    const domains = Object.keys(templatesByDomain);
    const mainProcessDescription = templatesByDomain[domains[0]]?.process_description || 'Fluxo de coleta estruturada';
    
    instructions += '<!-- ====================================================================== -->\n';
    instructions += '<!-- INSTRUÇÕES DE DATA COLLECTION - GERADO AUTOMATICAMENTE -->\n';
    instructions += '<!-- Templates: ' + selectedTemplates.length + ' | Domínios: ' + domains.join(', ') + ' -->\n';
    instructions += '<!-- Processo: ' + mainProcessDescription + ' -->\n';
    instructions += '<!-- Gerado em: ' + new Date().toLocaleString('pt-BR') + ' -->\n';
    instructions += '<!-- ====================================================================== -->\n\n';

    // ====================================================================
    // 1. TEMPLATE COMPLETO DE PROMPT
    // ====================================================================
    instructions += generateCompletePromptTemplate(domains, mainProcessDescription);

    // ====================================================================
    // 2. MANDATORY FUNCTIONS
    // ====================================================================
    instructions += generateMandatoryFunctions();

    // ====================================================================
    // 3. SCHEMA FIELD MAPPING (mantém atual - já está perfeito)
    // ====================================================================
    instructions += generateSchemaFieldMapping(allSelectedTemplates);

    // ====================================================================
    // 4. CONVERSATION FLOW INTELIGENTE (NOVO - USA TODOS OS CAMPOS)
    // ====================================================================
    instructions += generateIntelligentConversationFlow(templatesByDomain, allSelectedTemplates);

    // ====================================================================
    // 5. CRITICAL MAPPING RULES DINÂMICAS (NOVO - BASEADO NOS DADOS REAIS)
    // ====================================================================
    instructions += generateDynamicMappingRules(allSelectedTemplates);

    // ====================================================================
    // 6. RESPONSE RULES (mantém atual)
    // ====================================================================
    instructions += generateResponseRules();

    return instructions;
    
  } catch (error) {
    console.error('Erro ao gerar instruções melhoradas:', error);
    return 'Erro ao gerar instruções: ' + error.message;
  }
};

// ====================================================================
// FUNÇÕES AUXILIARES PARA GERAÇÃO DE PROMPT MELHORADA
// ====================================================================

const generateCompletePromptTemplate = (domains, processDescription) => {
  const mainDomain = domains[0] || 'geral';
  const domainCapitalized = mainDomain.charAt(0).toUpperCase() + mainDomain.slice(1);
  
  return `<agent_identity>
    <name>{{agent_name}}</name>
    <role>Especialista em ${domainCapitalized}</role>
    <personality>Carismático, eficiente, natural e acolhedor</personality>
    <objective>Qualificar leads e coletar dados estruturados para ${mainDomain}</objective>
</agent_identity>

<confidentiality_rules>
    <rule>NUNCA mencione detalhes técnicos do sistema</rule>
    <rule>NUNCA cite nomes de campos, templates ou estruturas internas</rule>
    <rule>NUNCA explique o mapeamento de dados ao usuário</rule>
    <rule>SEJA TRANSPARENTE - O usuário não deve saber que há um sistema por trás</rule>
    <rule>FALE NATURALMENTE - Como se fosse uma conversa humana normal</rule>
</confidentiality_rules>

<core_philosophy>
    <principle>ZERO REDUNDÂNCIA - Se o usuário já disse algo, NUNCA peça novamente</principle>
    <principle>ACEITE TUDO - Qualquer formato é válido</principle>
    <principle>SEJA HUMANO - Fale como pessoa, não como robô</principle>
    <principle>EXECUTE FUNCTIONS - Dados devem ser salvos automaticamente (INVISÍVEL ao usuário)</principle>
    <principle>MAPEAMENTO SILENCIOSO - Use campos exatos dos schemas SEM mencionar ao usuário</principle>
</core_philosophy>

<internal_operations>
    <note>Todas as operações técnicas (mapeamento de campos, execução de functions, validações) devem ser INVISÍVEIS ao usuário</note>
    <note>Se houver erro de mapeamento, corrija internamente sem mencionar</note>
    <note>O usuário deve ter uma experiência fluida e natural</note>
    <note>Schemas são injetados automaticamente pelo sistema baseados na configuração do agente</note>
    <note>Processo: ${processDescription}</note>

    <anti_redundancy_policy>
        <rule>Antes de perguntar, calcule missing = {campos_required_do_template} − {campos_ja_coletados}</rule>
        <rule>Pergunte APENAS os campos em missing</rule>
        <rule>Extração oportunista: de uma resposta, extraia múltiplos campos quando possível</rule>
        <rule>Confirme no máximo UMA vez se houver ambiguidade; não re-pergunte o mesmo campo</rule>
        <rule>Reutilize dados já coletados em identificação (nome_completo, telefone, cidade_estado, data_nascimento) nos demais templates</rule>
        <rule>Ao completar os required, EXECUTE coletar_dados_estruturados imediatamente</rule>
    </anti_redundancy_policy>

    <data_mapping_policy>
        <rule>Mapeie respostas para os names dos campos do schema (não use display_name ao salvar)</rule>
        <rule>Normalize enums para minúsculo e sem acento (ex.: "Não" → "nao")</rule>
        <rule>Converta números em string para número quando aplicável (ex.: "16" → 16)</rule>
        <rule>Se o valor não estiver no enum, normalize por sinônimos antes de perguntar novamente</rule>
    </data_mapping_policy>

    <qualification_policy>
        <rule>Após salvar, use qualified_for_next_step, qualification_status e next_step para ofertar agendamento</rule>
        <rule>O status vem das regras do template; não explique isso ao usuário</rule>
    </qualification_policy>
</internal_operations>

`;
};

const generateMandatoryFunctions = () => {
  return `<mandatory_functions>
    <rule>SEMPRE que coletar nome + telefone + data_nascimento → EXECUTE coletar_dados_estruturados</rule>
    <rule>SEMPRE que coletar dados de qualquer especialidade → EXECUTE coletar_dados_estruturados</rule>
    <rule>USE OS NOMES DE CAMPOS EXATOS conforme schemas</rule>
</mandatory_functions>

`;
};

const generateSchemaFieldMapping = (allSelectedTemplates) => {
  let mapping = '<schema_field_mapping>\n';
  
  // Ordenar todos os templates por domain e usage_order
  const allTemplatesSorted = allSelectedTemplates.sort((a, b) => {
    if (a.domain !== b.domain) return a.domain.localeCompare(b.domain);
    return (a.usage_order || 999) - (b.usage_order || 999);
  });

  allTemplatesSorted.forEach(template => {
    mapping += '    <template name="' + template.template_name + '">\n';
    mapping += '        <field_names>\n';
    
    // Extrair campos do schema_definition
    const fields = template.schema_definition?.fields || [];
    fields.forEach(field => {
      let fieldLine = '            <field name="' + field.name + '" required="' + (field.required || false) + '"';
      
      if (field.type && field.type !== 'string') {
        fieldLine += ' type="' + field.type + '"';
      }
      
      if (field.options && field.options.length > 0) {
        fieldLine += ' options="' + field.options.join(',') + '"';
      }
      
      fieldLine += ' />';
      mapping += fieldLine + '\n';
    });
    
    mapping += '        </field_names>\n';
    mapping += '    </template>\n\n';
  });
  
  mapping += '</schema_field_mapping>\n\n';
  return mapping;
};

const generateIntelligentConversationFlow = (templatesByDomain, allSelectedTemplates) => {
  let flow = '<conversation_flow>\n';
  
  // STEP 1: Identificação (dinâmica baseada nos templates)
  const identificacaoTemplate = allSelectedTemplates.find(t => 
    t.category === 'identificacao' || 
    t.template_name.includes('identificacao') ||
    t.usage_order === 1
  );
  
  if (identificacaoTemplate) {
    flow += generateIdentificationStep(identificacaoTemplate);
  }

  // STEP 2: Qualificação por especialidade (completamente dinâmica)
  flow += '    <step id="2" name="qualificacao_por_especialidade">\n';
  
  Object.entries(templatesByDomain).forEach(([domain, domainInfo]) => {
    const qualificacaoTemplates = domainInfo.templates.filter(t => 
      t.category !== 'identificacao' && 
      t.category !== 'agendamento' && 
      !t.template_name.includes('agendamento') &&
      !t.template_name.includes('identificacao')
    );

    qualificacaoTemplates.forEach(template => {
      flow += generateSpecialtySection(template);
    });
  });
  
  flow += '    </step>\n\n';

  // STEP 3: Análise e Agendamento (dinâmico baseado nos templates)
  const agendamentoTemplate = allSelectedTemplates.find(t => 
    t.category === 'agendamento' || 
    t.template_name.includes('agendamento')
  );
  
  if (agendamentoTemplate) {
    flow += generateSchedulingStep(agendamentoTemplate);
  }
  
  flow += '</conversation_flow>\n\n';
  return flow;
};

const generateIdentificationStep = (template) => {
  const domain = template.domain || 'geral';
  const whenToUse = template.when_to_use || 'Use SEMPRE no início de qualquer atendimento';
  const promptInstructions = template.prompt_instructions || 'Colete dados básicos de identificação';
  const description = template.description || 'Dados básicos de identificação';
  
  return `    <step id="1" name="identificacao_completa">
        <trigger>Quando usuário mencionar qualquer especialidade ${domain}</trigger>
        <description>${description}</description>
        <when_to_use>${whenToUse}</when_to_use>
        <instructions>${promptInstructions}</instructions>
        
        <action>Calcule missing e pergunte APENAS o que faltar entre: nome_completo, data_nascimento, telefone, cidade_estado, motivo_contato</action>
        <example>"Entendi, [especialidade]! Para te ajudar, preciso do seu nome completo, telefone, data de nascimento e cidade/estado."</example>
        
        <execute_when>Tiver nome + telefone + data_nascimento + cidade + motivo</execute_when>
        <function>coletar_dados_estruturados</function>
        <template>${template.template_name}</template>
    </step>

`;
};

const generateSpecialtySection = (template) => {
  // Extrair nome da especialidade
  let especialidade = template.template_name
    .replace(/^(previdenciario|juridico|vendas|rh|suporte)_/, '');
  
  const displayName = template.display_name || template.template_name;
  const description = template.description || '';
  const whenToUse = template.when_to_use || 'Use após identificação básica';
  const promptInstructions = template.prompt_instructions || 'Colete dados específicos da especialidade';
  
  // 🚀 EXTRAIR BUSINESS RULES AUTOMATICAMENTE
  const businessRules = template.schema_definition?.validation_rules?.business_rules || [];
  let qualificationRule = '<!-- DEFINIR REGRA DE QUALIFICAÇÃO BASEADA NOS CAMPOS -->';
  let qualificationMessage = '"✅ Seu caso tem fundamento! Vou agendar análise..."';
  
  if (businessRules.length > 0) {
    const rule = businessRules[0];
    // Converter regra técnica para linguagem mais amigável
    qualificationRule = rule
      .replace('qualify_for_consultation', 'QUALIFICADO para próxima etapa')
      .replace(/==/g, '=')
      .replace(/"/g, '"');
    
    // Gerar mensagem específica baseada no display_name
    const serviceType = displayName.replace('Qualificação - ', '').toLowerCase();
    qualificationMessage = `"✅ Seu caso de ${serviceType} tem fundamento! Vou agendar análise..."`;
  }

  let section = `        <${especialidade}>
            <display_name>${displayName}</display_name>
            <description>${description}</description>
            <when_to_use>${whenToUse}</when_to_use>
            <instructions>${promptInstructions}</instructions>
            
            <questions>
`;

  // Gerar perguntas baseadas nos display_names dos campos
  const fields = template.schema_definition?.fields || [];
  fields.forEach((field, index) => {
    if (index < 6) { // Máximo 6 perguntas
      const pergunta = field.display_name || field.name.replace(/_/g, ' ');
      section += `                <q${index + 1}>"${pergunta}"</q${index + 1}>\n`;
    }
  });
  
  section += `            </questions>
            <template>${template.template_name}</template>
            <qualified_if>${qualificationRule}</qualified_if>
            <message>${qualificationMessage}</message>
        </${especialidade}>

`;

  return section;
};

const generateSchedulingStep = (template) => {
  const promptInstructions = template.prompt_instructions || 'Execute quando cliente qualificado';
  const whenToUse = template.when_to_use || 'Use após qualificação positiva';
  const description = template.description || 'Agendamento de consulta';
  
  // Extrair perguntas de agendamento dos campos dinamicamente
  const fields = template.schema_definition?.fields || [];
  let schedulingQuestions = '';
  
  fields.forEach(field => {
    const pergunta = field.display_name || field.name.replace(/_/g, ' ');
    schedulingQuestions += `            <ask>"${pergunta}"</ask>\n`;
  });

  return `    <step id="3" name="analise_qualificacao">
        <trigger>IMEDIATAMENTE após salvar dados de qualificação</trigger>
        <description>${description}</description>
        <when_to_use>${whenToUse}</when_to_use>
        <instructions>${promptInstructions}</instructions>
        
        <if>Use qualified_for_next_step, qualification_status e next_step retornados pela function</if>
        <then_qualified>OFEREÇA agendamento automático com mensagem específica</then_qualified>
        <then_not_qualified>"Nossa equipe vai analisar seu caso e entrar em contato em 24h"</then_not_qualified>
        
        <collect_scheduling>
${schedulingQuestions}        </collect_scheduling>
        
        <execute_functions>
            <function>coletar_dados_estruturados("${template.template_name}")</function>
            <then>schedule_event</then>
        </execute_functions>
    </step>
`;
};

const generateDynamicMappingRules = (allSelectedTemplates) => {
  let rules = '<critical_mapping_rules>\n';
  rules += '    <rule>USE nomes de campos EXATOS conforme schema_field_mapping</rule>\n';
  
  // 🚀 EXTRAIR REGRAS ESPECÍFICAS DOS TEMPLATES AUTOMATICAMENTE
  const allFields = [];
  allSelectedTemplates.forEach(template => {
    const fields = template.schema_definition?.fields || [];
    allFields.push(...fields);
  });
  
  // Identificar campos enum para regras específicas
  const enumFields = allFields.filter(field => field.type === 'enum');
  if (enumFields.length > 0) {
    rules += '    <rule>Para campos enum, use apenas as opções listadas no schema</rule>\n';
  }
  
  // Identificar padrões comuns automaticamente
  const hasDataNascimento = allFields.some(field => field.name === 'data_nascimento');
  if (hasDataNascimento) {
    rules += '    <rule>CAMPO: data_nascimento SEMPRE obrigatório na identificação</rule>\n';
  }
  
  // Regras de formatação baseadas nos campos encontrados
  const hasSimNaoFields = enumFields.some(field => 
    field.options && field.options.includes('sim') && field.options.includes('nao')
  );
  if (hasSimNaoFields) {
    rules += '    <rule>VALOR: "sim" (NÃO "Sim" capitalizado)</rule>\n';
    rules += '    <rule>VALOR: "nao" (NÃO "não" com acento)</rule>\n';
  }
  
  // Detectar campos de entrada anterior automaticamente
  const hasEntradaFields = allFields.some(field => 
    field.name.includes('ja_deu_entrada') || field.name.includes('ja_pediu')
  );
  if (hasEntradaFields) {
    rules += '    <rule>PADRÃO: Para perguntas de entrada anterior, use "nao", "sim_aprovado", "sim_negado"</rule>\n';
  }
  
  rules += '    <rule>Execute coletar_dados_estruturados() IMEDIATAMENTE após coletar dados</rule>\n';
  rules += '    <rule>MAPEAMENTO SILENCIOSO: Use campos corretos mas nunca mencione isso ao usuário</rule>\n';
  rules += '    <rule>NUNCA invente nomes de campos - USE EXATAMENTE os especificados no schema</rule>\n';
  rules += '</critical_mapping_rules>\n\n';
  
  return rules;
};

const generateResponseRules = () => {
  return `<response_rules>
    <rule id="no_redundancy">NUNCA repita informações já coletadas</rule>
    <rule id="accept_everything">Aceite qualquer formato de dados</rule>
    <rule id="execute_functions">Execute coletar_dados_estruturados IMEDIATAMENTE após coletar dados (SEM mencionar ao usuário)</rule>
    <rule id="use_exact_fields">Use nomes de campos EXATOS dos schemas (injetados automaticamente acima)</rule>
    <rule id="qualify_and_schedule">Se qualified_for_next_step=true, OFEREÇA agendamento imediatamente</rule>
    <rule id="no_technical_details">NUNCA mencione aspectos técnicos do sistema</rule>
    <rule id="natural_conversation">Mantenha conversa natural e humana sempre</rule>
    <rule id="immediate_execution">Execute functions IMEDIATAMENTE após coletar dados, não peça confirmação</rule>
</response_rules>`;
};

// Funções auxiliares para ícones profissionais
const getDomainIcon = (domain) => {
  const iconMap = {
    'juridico': <GavelIcon fontSize="small" />,
    'vendas': <BusinessIcon fontSize="small" />, 
    'suporte': <SupportIcon fontSize="small" />,
    'rh': <PeopleIcon fontSize="small" />,
    'saude': <FeedbackIcon fontSize="small" />,
    'educacao': <KnowledgeIcon fontSize="small" />,
    'financeiro': <AssessmentIcon fontSize="small" />,
    'marketing': <ChatIcon fontSize="small" />,
    'ti': <BuildIcon fontSize="small" />,
    'logistica': <WorkIcon fontSize="small" />
  };
  return iconMap[domain] || <ListIcon fontSize="small" />;
};

const getCategoryIcon = (category) => {
  const iconMap = {
    'identificacao': <PersonIcon fontSize="small" />,
    'qualificacao': <AssessmentIcon fontSize="small" />,
    'previdenciario': <GavelIcon fontSize="small" />, 
    'agendamento': <ScheduleIcon fontSize="small" />,
    'atendimento': <ChatIcon fontSize="small" />,
    'consultoria': <BusinessIcon fontSize="small" />,
    'descoberta': <ContactPhoneIcon fontSize="small" />,
    'proposta': <AssignmentIcon fontSize="small" />,
    'ticket': <BugReportIcon fontSize="small" />,
    'recrutamento': <PeopleIcon fontSize="small" />,
    'avaliacao': <AssessmentIcon fontSize="small" />,
    'admissao': <FeedbackIcon fontSize="small" />,
    'consulta': <ScheduleIcon fontSize="small" />,
    'enriquecimento': <ContactPhoneIcon fontSize="small" />,
    'contratacao': <AssignmentIcon fontSize="small" />,
    'tickets': <BugReportIcon fontSize="small" />,
    'diagnostico': <BuildIcon fontSize="small" />,
    'satisfacao': <FeedbackIcon fontSize="small" />
  };
  return iconMap[category] || <AssignmentIcon fontSize="small" />;
};

export default ToolsConfiguration;